import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    accessToken: null,
    refreshToken: null,
    user: null,
    phone: null,
    email: null,
    customerStatus: null, // 'LOGIN' | 'REGISTER' | null
    isPhoneParamProvided: false,
    uuid: null,
  }),
  getters: {
    userId: (state) => state.user?.id || null,
    userName: (state) => state.user?.name || null,
    userFullName: (state) => state.user?.full_name || null,
    isAuthenticated: (state) => !!state.accessToken,
  },
  actions: {
    login({ accessToken, refreshToken, user }) {
      if (accessToken) this.accessToken = accessToken
      if (refreshToken) this.refreshToken = refreshToken
      if (user) this.user = user
    },
    setAccessToken(token) {
      this.accessToken = token
    },
    setRefreshToken(token) {
      this.refreshToken = token
    },
    setUser(user) {
      this.user = user
    },
    setPhone(phone) {
      this.phone = phone
    },
    setEmail(email) {
      this.email = email
    },
    setCustomerStatus(status) {
      this.customerStatus = status
    },
    setIsPhoneParamProvided(value) {
      this.isPhoneParamProvided = value
    },
    logout() {
      this.$reset()
    },
    clearAuth() {
      this.$reset()
    },
  },
  persist: {
    paths: ['accessToken', 'refreshToken', 'user', 'phone', 'email', 'customerStatus', 'isPhoneParamProvided', 'uuid'],
  },
})
